import { RoomId, roomId, RoomMixerId, roomMixerId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomMixerErrorEventDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomMixerErrorEventDTO.validationSchema()
  );

  readonly data: RoomMixerErrorEvent;

  constructor(data: RoomMixerErrorEvent) {
    this.data = JsonSchemaValidator.assert(
      RoomMixerErrorEventDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "error"],
      properties: {
        roomId,
        mixerId: roomMixerId,
        error: {
          type: "string",
          minLength: 0,
          maxLength: 1024
        }
      },
      additionalProperties: false
    };
  }
}

export interface RoomMixerErrorEventJson extends RoomMixerErrorEvent {}

interface RoomMixerErrorEvent {
  roomId: RoomId;
  mixerId?: RoomMixerId;
  error: string;
}
